import "src/decidim/attachments/file_or_link_tabs";
